"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBrandToShortBrand = exports.transformShortBrandToBrand = void 0;
const enums_1 = require("../enums");
const shortBrandToBrandMap = {
    [enums_1.ShortBrand.JochenSchweizer]: enums_1.Brand.JochenSchweizer,
    [enums_1.ShortBrand.Mydays]: enums_1.Brand.Mydays,
};
const brandToShortBrandMap = {
    [enums_1.Brand.JochenSchweizer]: enums_1.ShortBrand.JochenSchweizer,
    [enums_1.Brand.Mydays]: enums_1.ShortBrand.Mydays,
};
const transformShortBrandToBrand = (shortBrand) => {
    return shortBrandToBrandMap[shortBrand];
};
exports.transformShortBrandToBrand = transformShortBrandToBrand;
const transformBrandToShortBrand = (brand) => {
    return brandToShortBrandMap[brand];
};
exports.transformBrandToShortBrand = transformBrandToShortBrand;
//# sourceMappingURL=transformBrands.js.map